import { MessageCircle, Send, ShieldCheck } from "lucide-react";
import { LINKS } from "../../data/site";
import { useSite } from "../../context/SiteContext";

const BASE_CHANNELS = [
  { key: "whatsapp", label: "WhatsApp", icon: MessageCircle, color: "#25D366" },
  { key: "telegram", label: "Telegram", icon: Send, color: "#229ED9" },
  { key: "signal", label: "Signal", icon: ShieldCheck, color: "#3A76F0" },
];

export const useLinks = () => ({ ...LINKS, ...(useSite().site?.contacts || {}) });

export const useChannels = () => {
  const links = useLinks();
  return BASE_CHANNELS.map((c) => ({ ...c, href: links[c.key] }));
};

export const Logo = () => (
  <a href="/#top" data-testid="header-logo" className="flex items-baseline gap-1 font-serif">
    <span className="text-base sm:text-2xl font-bold tracking-wider gold-text">DADDYANNA</span>
    <span className="text-sm font-bold text-white">247</span>
  </a>
);

export const Eyebrow = ({ children }) => (
  <div className="flex items-center gap-3 text-xs uppercase tracking-[0.3em] text-[#D4AF37]">
    <span className="h-px w-10 bg-gradient-to-r from-transparent to-[#D4AF37]" />
    {children}
  </div>
);

export const Filigree = () => (
  <svg viewBox="0 0 200 20" className="h-4 w-40 text-[#D4AF37]" aria-hidden>
    <path d="M0 10 H80 M120 10 H200" stroke="currentColor" strokeWidth="0.6" />
    <path d="M100 2 L108 10 L100 18 L92 10 Z" fill="none" stroke="currentColor" strokeWidth="0.8" />
    <path d="M80 10 C86 2, 92 2, 92 10 M120 10 C114 18, 108 18, 108 10" fill="none" stroke="currentColor" strokeWidth="0.6" />
    <circle cx="100" cy="10" r="1.6" fill="currentColor" />
  </svg>
);

export const SectionHead = ({ eyebrow, title, sub }) => (
  <div className="mb-14 max-w-2xl">
    <Eyebrow>{eyebrow}</Eyebrow>
    <h2 className="mt-5 font-serif text-3xl font-bold uppercase tracking-tight text-white sm:text-4xl">{title}</h2>
    <div className="mt-4"><Filigree /></div>
    {sub && <p className="mt-4 text-base text-zinc-400 md:text-lg">{sub}</p>}
  </div>
);
